import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/login']);
};

/** Keeps an already-authenticated user out of the /login screen. */
export const loginRedirectGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};

/**
 * SuperAdmin-only routes (Console Admins management). UI-convenience gating only — every action on
 * that page still hits an endpoint the backend independently re-checks (ConsoleAdmins.Manage), so
 * this guard existing purely means a non-SuperAdmin never even sees the page shell.
 */
export const superAdminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }
  if (!authService.isSuperAdmin()) {
    return router.createUrlTree(['/companies']);
  }
  return true;
};
